import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import AttachFilesForm from '../../attachfiles/AttachFilesForm'
import { useForm, Controller } from 'react-hook-form'
import { cloneDeep } from 'lodash-es'
import {
  getAttachments,
  saveAttachments,
  updateAttachments,
  deleteAttachments,
  getDownload,
} from '../../../redux/actions/projectManagement'
import { startLoading, doneLoading } from '../../../utils/loading'

export default function ProjectManageAttachWidget(props) {
  const { onDownload, onPreview } = props

  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      const response = await updateAttachments(projectId, request)

      console.log('response', response)

      if (response) {
        setIsEditErr(false)
        setFormSchema(response)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveAttachments(projectId, request)

      console.log('response', response)

      if (response) {
        setFormSchema(response)
        setIsUploadErr(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteAttachments(projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getAttachments(projectId)
        console.log('result', _schema)
        setFormSchema(_schema)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.name]

    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file['userId'] = 111
    file.label = newName

    console.log('file', file)
    handleUpdate(file)
  }

  const onDelete = (index) => {
    // console.log('handleDelete', index)
    let datas = [...formSchema.value]
    handleDelete(datas[index])
  }

  return (
    <div className="component-overview">
      <AttachFilesForm
        schema={formSchema}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
        onSubmit={handleSubmit(onUpload)}
        onDelete={onDelete}
        onUpdate={onUpdate}
        onDownload={onDownload}
        onPreview={onPreview}
        isEditErr={isEditErr}
        isUploadErr={isUploadErr}
        isDeleteError={isDeleteError}
        loading={isLoading}
      />
    </div>
  )
}
